import styled from 'styled-components'
import { theme } from '@/client/components'
const { space, breakpoint } = theme

export const Featured = styled.div`
  padding-bottom: ${space.xl3};

  @media (min-width: ${breakpoint.lg}) {
    padding: ${space.lg} 0 ${space.xl3};
  }
`

export const LeftFeatured = styled.div`
  width: 100%;
  margin-bottom: ${space.lg};
`
export const LottieFeatured = styled.div`
  width: 65%;
`
